<template lang="pug">
div
	v-e24-nav-bar
	SectionTitle(isAccordions='true' :srcImage='imgHeader', :tall="tall", h1="My projects")
	section.maincolumn-constrained
		.app-page
			//- list-projects
			.main-container
				//- list-container
				.child-container
					.create-project-btn
						h2.title-list Projects in Progress
						p.create-new-project
							router-link.link-ui(:to="{name:'project.new'}")
								img(:src='imgIconCreate')
								| Create New Project

					div
						ag-grid-vue.ag-theme-balham(
						style="width: 100%",
						class="ag-theme-balham",
						:defaultColDef='defaultColDef',
						:columnDefs="columnDefs",
						:rowData="projInProgress",
						pagination='true',
						paginationPageSize='15',
						v-if="projInProgress.length > 0 && greenFlag && goGrid",
						v-on:gridReady='onGridReady',
						)

					div
						.not-projects(v-if="!greenFlag")
							h4 Loading projects...
							.icon-empty-envelope
								img(:src="loadingIcon")

					div(v-show="projInProgress.length > 0 && greenFlag && !goGrid")
						.not-projects
							h4 Loading projects...
							.icon-empty-envelope
								img(v-show="projInProgress.length > 0", :src="loadingIcon")

					div(v-show="projInProgress.length < 1 && greenFlag")
						.not-projects
							h4 No projects
							.icon-empty-envelope
								img(:src="emptyIcon")

					div(v-if="projLocked.length > 0 && greenFlag && goGrid")
						h2.title-list Submitted Projects

					#projLocked
						ag-grid-vue.ag-theme-balham(
						style="width: 100%",
						class="ag-theme-balham",
						:defaultColDef='defaultColDef',
						:columnDefs="columnDefsLock",
						:rowData="projLocked",
						pagination='true',
						paginationPageSize='15',
						v-if="projLocked.length > 0 && greenFlag && goGrid",
						v-on:gridReady='onGridReady'
						)

	v-e24-footer(:build="build")

	b-modal#modalxl(v-if="showProjectPreview", v-model="showProjectPreview", hide-footer size="lg", :title="titleName")
		project-preview.project-preview(:proj-id="this.project.projId", v-if="!isLegacy && popUpPreview === 'projects' ")
		print-legacy.project-preview(:proj-id="this.project.projId", v-if="isLegacy && popUpPreview === 'projects' ")
		agGridPreviewOrderPopUp(:order-prop="order", :order-d-prop="orderDate", :contacts-prop="contacts", :card-prop="card" v-if="popUpPreview === 'orders' ")
		.content-btn( style="width: 100%; display: flex; justify-content:center;")
			a(@click="showProjectPreview = false")
				easyBtn(btnText="Close")
</template>

<script>
import {mapState} from 'vuex'
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import {AgGridVue} from 'ag-grid-vue'

import { EventBus } from '@/common/event-bus.js'

import agGridProjectName from './ag-grid/progress-in-project-name.vue'

import agGridPreviewProject from './ag-grid/preview-project.vue'
import agGridPreviewOrderBtn from './ag-grid/preview-order-btn.vue'
import agGridPreviewOrderPopUp from './ag-grid/preview-order-component.vue'

import agGridAuditCopyDeleteProject from './ag-grid/audit-copy-delete-project.vue'
import agGridCopyProject from './ag-grid/clone-project.vue'
// import agGridCopyOderOrder from './ag-grid/copy-order-order.vue'

import ProjectPreview from 'App/project/preview-component.vue'
import PrintLegacy from 'App/project/print-legacy.vue'
import easyBtn from 'Common/components/easy-btn.vue'

import SectionTitle from '@/common/components/sectionTitle.vue'
import imageHeader from '@/common/img/list-project.jpg'
import iconEmpty from '@/common/img/baseline-list-24px.svg'
import Spinner from '@/common/img/Spinner-1s-200px.svg'
import imgIcon from '@/common/img/baseline-loupe-24px.svg'

import readBuild from '../../util/readBuild'

export default {
	name: 'project-list',
	components: {
		SectionTitle,
		AgGridVue,
		agGridProjectName,
		agGridPreviewProject,
		agGridPreviewOrderBtn,
		agGridPreviewOrderPopUp,
		agGridAuditCopyDeleteProject,
		agGridCopyProject,
		ProjectPreview,
		PrintLegacy,
		easyBtn
	},
	data () {
		return {
			build: '',
			imgHeader: imageHeader,
			tall: 90,
			imgIconCreate: imgIcon,
			emptyIcon: iconEmpty,
			loadingIcon: Spinner,
			greenFlag: false,
			goGrid: false,
			projInProgress: [],
			projLocked: [],
			legacyProjects: [],
			projType: {},
			defaultColDef: {
				resizable: true,
				sortable: true,
				filter: true
			},
			columnDefs: {field: 'name', sortable: true},
			columnDefsLock: {field: 'name', sortable: true},
			showProjectPreview: false,
			titleName: null,
			isLegacy: false,
			order: null,
			orderDate: null,
			contacts: null,
			card: null,
			responsiveState: null,
			project: '',
			orderStatus: ''
			// prjType: { 1: 'Warm Zone', 2: 'Cool Zone', 3: 'Addition' },
		}
	},
	beforeMount () {
		// console.log('project ', this.project)
		this.projType = process.env.PROJTYPE
		this.orderStatus = process.env.CHECKOUT.orderStatus
		this.columnDefs = [
			{
				headerName: '#',
				field: 'projId',
				width: 80
			},
			{
				headerName: 'Name',
				field: 'name',
				cellRendererFramework: agGridProjectName,
				width: 280
			},
			{
				headerName: 'Type',
				field: 'isNewHome',
				width: 120,
				valueGetter: (params) => {
					return this.projectTypeIdToLabel(params.data.takeoff)
				}
			},
			{
				headerName: 'Last edited',
				field: 'lastUpdate',
				width: 120,
				valueGetter: (params) => {
					return moment(params.data.lastUpdate).format('YYYY-MM-DD HH:mm')
				}
			},
			{
				headerName: '',
				width: 160,
				cellRendererFramework: agGridAuditCopyDeleteProject
			}
		]
		this.columnDefsLock = [
			{
				headerName: '#',
				field: 'projId',
				width: 80
			},
			{
				headerName: 'Name',
				width: 230,
				field: 'name',
				cellRendererFramework: agGridPreviewProject
			},
			{
				headerName: 'Type',
				field: 'isNewHome',
				width: 100,
				valueGetter: (params) => {
					return this.projectTypeIdToLabel(params.data.takeoff)
				}
			},
			{
				headerName: 'Last edited',
				field: 'lastUpdate',
				width: 95,
				valueGetter: (params) => {
					return moment(params.data.lastUpdate).format('YYYY-MM-DD HH:mm')
				}
			},
			{
				headerName: '',
				width: 38,
				sortable: false,
				filter: false,
				cellRendererFramework: agGridCopyProject
			},
			{
				headerName: 'Order #',
				width: 77,
				cellRendererFramework: agGridPreviewOrderBtn,
				sortable: false,
				filter: false
			},
			{
				headerName: 'Status',
				width: 73,
				sortable: false,
				filter: false,
				valueGetter: (params) => {
					if (!_.isNil(params.data.order)) {
						return _.find(this.orderStatus, {code: params.data.order.orderStatus}).label
					} else {
						return ''
					}
				}
			}

		]
		this.loadData()
	},
	mounted () {
		this.callEventBus()
		this.build = this.getBuild()
	},
	mixins: [readBuild],
	methods: {
		async loadData () {
			const projects = await Vue.e24.projectService.findByUserId(Vue.e24.security.currentUser.userId)
			let legacyProjects = await Vue.e24.projectService.findByUserId(Vue.e24.security.currentUser.userId, true)

			// List of projects in progress
			this.projInProgress = _.chain(projects)
				.filter({ isActive: 1, isLocked: 0 })
				.sortBy((prj) => { return (!_.isNil(prj.lastUpdate)) ? new Date(prj.lastUpdate) : moment('1990-01-01').toDate() })
				.sortBy((prj) => prj.projId)
				.value()
				.reverse()

			// starting loading flags
			this.initFlags()

			// List of locked projects
			this.projLocked = _.filter(projects, { isActive: 1, isLocked: 1 })
			legacyProjects = _.filter(legacyProjects, { isActive: 1 })
			this.projLocked = this.projLocked.concat(legacyProjects) // Legacy projects are merged with submitted ones

			// Order submited projects
			this.projLocked = _.chain(this.projLocked)
				.sortBy((prj) => { return (!_.isNil(prj.lastUpdate)) ? new Date(prj.lastUpdate) : moment('1990-01-01').toDate() })
				.sortBy((prj) => prj.projId)
				.value()
				.reverse()
		},
		dateFormat (date) {
			return (_.isNil(date)) ? '' : moment(date).format('YYYY-MM-DD')
		},
		projectTypeIdToLabel (takeoff) {
			let out = ''
			switch (takeoff) {
			case this.projType.warmZone:
				out = 'Warm Zone'
				break
			case this.projType.coolZone:
				out = 'Cool Zone'
				break
			case this.projType.addtnPrior2018:
				out = 'Addition'
				break
			case this.projType.newBuilding:
				out = 'New building'
				break
			case this.projType.ePlusAdd:
				out = 'Addition'
				break
			case this.projType.detachedAdd:
				out = 'Detached addition'
				break
			case this.projType.conversion:
				out = 'Conversion'
				break
			case this.projType.remodel:
				out = 'Remodel'
				break
			}
			return out
		},
		onGridReady (params) {
			params.api.sizeColumnsToFit()
		},
		initFlags () {
			// greenFlag
			// goGrid
			_.delay(() => {
				this.greenFlag = true
				// console.debug('greenFlag is true')
			}, 1000, 'later')

			_.delay(() => {
				this.goGrid = true
				// console.debug('goGrid is true')
			}, 1500, 'later')
		},
		callEventBus () {
			EventBus.$on('is-pop-up-on', (isPreview, PopType) => {
				this.popUpPreview = PopType
				this.project = isPreview
				this.isLegacy = (this.project.projId < 10000)
				this.showProjectPreview = true

				if (PopType === 'projects') {
					this.titleName = '# ' + this.project.projId + ' - ' + this.project.name
				}
			})
			EventBus.$on('orders-pop-up-on', (order, orderDate, contacts, card) => {
				this.order = order
				this.orderDate = orderDate
				this.contacts = contacts
				this.card = card

				this.popUpPreview = 'orders'
				// open popUp
				this.showProjectPreview = true
				this.titleName = '# ' + this.order.orderId + ' - Order Date: ' + this.orderDate
			})
			EventBus.$on('is-load-data', isLoading => {
				this.loadData()
				// console.debug('loadData is called from delete btn')
			})
		}
	},
	computed: mapState({
		navBarExpanded: state => state.navBarExpanded
	})
}
</script>



// WEBPACK FOOTER //
// src/app/project/list.vue